import React from "react";

import { faSparkles } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Tooltip } from "@performyard/py-components";

import { useAskPerformYardStore } from "../AskPerformYardStore";

type ChatTriggerProps = {
	className?: string;
};

/** Floating action button to open/close the chat window. */
export const ChatTrigger: React.FC<ChatTriggerProps> = ({ className }) => {
	const { open, close, isOpen } = useAskPerformYardStore();

	const handleClick = (): void => {
		if (isOpen) {
			close();
		} else {
			open();
		}
	};

	return (
		<div className={`hide-in-pdf fixed bottom-6 right-6 z-[150] ${className || ""}`}>
			<Tooltip
				offset={-4}
				placement="left"
				content={isOpen ? "Close" : "Ask PerformYard"}
				dangerouslySetClassName="z-[150]"
				asChild
			>
				<button
					onClick={handleClick}
					className="flex h-12 w-12 cursor-pointer items-center justify-center rounded-full border-none bg-[#3E90C1] text-white shadow-[0_4px_4px_0_rgba(0,0,0,0.25)] outline-none transition-all hover:scale-105 hover:bg-[#3580ad]"
					data-testid="ask-performyard-trigger"
					aria-label={isOpen ? "Close chat" : "Ask PerformYard"}
				>
					<FontAwesomeIcon icon={faSparkles} className="text-xl" />
				</button>
			</Tooltip>
		</div>
	);
};

export default ChatTrigger;
